module.exports = __webpack_public_path__ + "img/455.45244747.png";